//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import PlansMixin from '~/mixins/plans'

export default {
  mixins: [PlansMixin],
  props: {
    /**
     * Area page: diet | sex-drive | stress | energy | sleep
     */
    area: {
      type: String,
      required: true
    },
    /**
     * Biomarker name
     */
    biomarker: {
      type: String,
      required: true
    },
    /**
     * Whether to show the pay now button
     */
    showPayNowButton: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      slide: 0
    }
  },
  computed: {
    ...mapGetters({
      getPlanPriceRaw: 'product/getPlanPriceRaw'
    }),
    specifications () {
      return this.$t('area.header.specifications')
    },
    benefits () {
      return this.$t('area.header.benefits')
    }
  },
  methods: {
    emitOpenFastTrackModal () {
      this.$emit('trackAddToCart')
    }
  }
}
